import { render, staticRenderFns } from "./BlockText.vue?vue&type=template&id=10c32067"
import script from "./BlockText.vue?vue&type=script&lang=js"
export * from "./BlockText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports